const mediaItems = [
  {
    title: '奔跑吧·泥潭特辑',
    tag: '爆笑名场面',
    views: '128万次播放',
    img: 'https://readdy.ai/api/search-image?query=Muddy%20outdoor%20obstacle%20course%20scene%20with%20people%20laughing%20and%20playing%20in%20warm%20sunlight%20energetic%20group%20activity%20cinematic%20action%20photography%20with%20motion%20splashes%20vibrant%20natural%20colors%20joyful%20atmosphere%20variety%20show%20entertainment%20style&width=800&height=500&seq=media-01-6080&orientation=landscape',
  },
  {
    title: '歌手2025·神级现场',
    tag: '音乐高光',
    views: '96万次播放',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20concert%20stage%20with%20powerful%20spotlight%20beam%20illuminating%20a%20single%20microphone%20stand%20golden%20smoke%20and%20atmospheric%20haze%20warm%20amber%20and%20gold%20lighting%20emotional%20performance%20moment%20professional%20music%20photography%20with%20soft%20bokeh&width=800&height=500&seq=media-02-6080&orientation=landscape',
  },
  {
    title: '密室大逃脱·高能时刻',
    tag: '悬疑烧脑',
    views: '85万次播放',
    img: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20mysterious%20room%20with%20vintage%20furniture%20and%20candlelight%20atmosphere%20old%20bookshelves%20and%20hidden%20compartments%20warm%20amber%20glow%20casting%20long%20shadows%20suspenseful%20cinematic%20interior%20with%20dust%20particles%20floating%20in%20light%20beams&width=800&height=500&seq=media-03-6080&orientation=landscape',
  },
  {
    title: '脱口秀大会·爆梗合集',
    tag: '笑到停不下来',
    views: '156万次播放',
    img: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20comedy%20club%20stage%20with%20single%20microphone%20under%20soft%20spotlight%20red%20curtain%20background%20cozy%20atmosphere%20with%20warm%20tungsten%20lighting%20laughter%20and%20joy%20vibe%20professional%20standup%20comedy%20photography%20with%20film%20grain&width=800&height=500&seq=media-04-6080&orientation=landscape',
  },
  {
    title: '乘风破浪·神仙舞台',
    tag: '姐姐高光',
    views: '112万次播放',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20flowing%20dresses%20and%20dynamic%20dance%20formation%20sparkling%20stage%20lights%20in%20rose%20gold%20and%20warm%20tones%20empowering%20group%20choreography%20professional%20dance%20photography%20glamorous%20entertainment%20show%20atmosphere%20with%20confetti%20falling&width=800&height=500&seq=media-05-6080&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            精彩片段速览
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            热门综艺的高光名场面，快速回味最精彩瞬间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <a key={item.title} href="#media" onClick={(e) => e.preventDefault()} className="group block cursor-pointer">
              <div className="bg-background-50 rounded-xl overflow-hidden border border-background-300/20 transition-all duration-300 hover:border-accent-500/25">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-background-50/20 group-hover:bg-background-50/10 transition-colors flex items-center justify-center">
                    <div className="w-11 h-11 rounded-full bg-primary-500/85 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                      <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 bg-background-50/80 backdrop-blur-sm text-foreground-700 text-[10px] font-medium rounded-md whitespace-nowrap">
                      {item.views}
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <span className="text-[10px] text-accent-400 font-medium whitespace-nowrap">{item.tag}</span>
                  <h3 className="font-heading font-semibold text-xs text-foreground-200 mt-1 group-hover:text-primary-400 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}